import React from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

export default function StoreList() {
  const { products } = useAppContext();

  const handleDirectPurchase = (url) => {
    if (url) window.open(url, '_blank');
  };

  return (
    <div className="py-12 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-extrabold text-gray-900 mb-4 tracking-tight">Shop TapBadges</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            The last business card you'll ever need. Share your profile with a simple tap.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {products.map((product, idx) => {
            const hasStripe = !!product.stripe_checkout_url;
            
            return (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 }}
                className="bg-white rounded-3xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all group flex flex-col"
              >
                <div className="relative h-64 overflow-hidden bg-gray-100">
                  <img
                    src={product.image_url}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 bg-white/95 backdrop-blur px-3 py-1 rounded-full text-sm font-bold text-gray-900 shadow-sm">
                    ${product.price}
                  </div>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="mb-4">
                    <h3 className="text-xl font-bold text-gray-900 mb-1">{product.name}</h3>
                    <span className="text-[10px] font-bold text-indigo-600 uppercase tracking-widest">{product.type}</span>
                  </div>
                  
                  <p className="text-gray-500 text-sm mb-6 flex-1 line-clamp-2 leading-relaxed">
                    {product.description}
                  </p>
                  
                  <div className="space-y-3">
                    {hasStripe && (
                      <button
                        onClick={() => handleDirectPurchase(product.stripe_checkout_url)}
                        className="w-full bg-indigo-600 text-white py-3.5 rounded-2xl font-bold hover:bg-indigo-700 transition-colors flex items-center justify-center gap-2 shadow-lg shadow-indigo-100"
                      >
                        <SafeIcon name="CreditCard" />
                        Buy with Stripe
                      </button>
                    )}
                    
                    <Link
                      to={`/store/${product.id}`}
                      className={`w-full block text-center py-3.5 rounded-2xl font-bold transition-all ${
                        hasStripe 
                        ? 'bg-gray-100 text-gray-700 hover:bg-gray-200' 
                        : 'bg-gray-900 text-white hover:bg-gray-800'
                      }`}
                    >
                      {product.is_customizable ? 'Customize & Details' : 'View Details'}
                    </Link>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
